import type { DeepPartial } from '@luna/utils-ts';
import type { CurrentAccountSettingsDetailsConfig } from '@shared/products-feature-configs';

export const settingsDetails: DeepPartial<CurrentAccountSettingsDetailsConfig> = {
    displayAccountOwner: true,
    displayBalance: true,
    displayCancelledState: true,
    displayCreationDate: true,
    displayDebitInterestRate: true,
    displayDisposable: true,
    displayOverdraft: true,
    displayOverdraftApprovedLimit: true,
    displayOverdraftClientLimit: true,
    displayOverdraftDateSpan: true,
    displayOverdraftDueDate: true,
    displayRoUsedOverdraft: true,
    displayBIC: true,
    displayIBAN: true,
    shouldHideOverdraftAmountRow: true,
    shouldHideSeparatedBalance: true,
};
